export default "assets/images/sowine-note-2d7bd928.png";